<!--ACTIVIDADES, ASIGNAGTURAS Y GRADOS-->
<article class="d_principal d_section_actividades">

    <div class="d_headernav d_searchacts" id="d_navhome" style="display: flex;">
        <!--SEARCH BAR HOME-->
        <div class="d_headersearchgrl">
            <input (input)="onSearch()" [(ngModel)]="searchTerm" class="d_headersearchinput"
                placeholder="Buscar actividades educativas">

            <div *ngIf="searchTerm && searchTerm.trim() !== '' else clearIcon" class="d_headersearchicon"
                [innerHTML]="_icon.filterclear" (click)="searchTerm = ''; onSearch()"></div>

            <ng-template #clearIcon>
                <div class="d_headerclearicon" [innerHTML]="_icon.search" style="display: flex;"></div>
            </ng-template>

        </div>
    </div>

    <h1 class="d_subtitulo">Nuestras actividades</h1>
    <div class="d_principalin d_ajustegridflex" id="container_apps">

        <div class="d_galeria_actividades" *ngFor="let actividad of paginadoListAplicaciones; let i = index"
            (click)="onOpenApp(actividad)"
            (mouseenter)="showShareButton(i, actividad)"
            (mouseleave)="hideShareButton(i)">
            <div class="d_galeria_actividadesconte">
                <img [src]="url_img_app + actividad.p + '.png'" />
                <span class="d_galeria_categos">
                    <!--ICONOS DE CATEGORIAS-->
                    <img src="assets/redi/icons/categorias/{{ (actividad.cg || '').toLocaleLowerCase() | removeAccents }}.svg" />
                </span>
                <div class="sharetoclassroom" id="gshare-{{i}}"></div>
            </div>
            <p class="galeria__texto">{{ actividad.n }}</p>
        </div>


    </div>
    <div class="pagination">
        <!-- <button class="arrow">
            <img [src]="_icon.left_arrow" alt="Left Arrow" />
        </button>
        <a href="#" class="page active">1</a>
        <a href="#" class="page">2</a>
        <a href="#" class="page">3</a>
        <a href="#" class="page">4</a>
        <span class="dots">...</span>
        <button class="arrow">
            <img [src]="_icon.right_arrow" alt="Right Arrow" />
        </button> -->
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [showCurrentPageReport]="true" [showPageLinks]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [showFirstLastIcon]="true" />
    </div>
</article>
